import { render, staticRenderFns } from "./s01.vue?vue&type=template&id=9907252e"
import script from "./s01.vue?vue&type=script&lang=js"
export * from "./s01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports